import React, { useEffect, useState } from "react";
import MLBOptimizer from "./MLBOptimizer";
import MLBLateSwap from "./MLBLateSwap";

const useStickyState = (key, init) => {
  const [v, setV] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw != null ? JSON.parse(raw) : init;
    } catch {
      return init;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(v));
    } catch {}
  }, [key, v]);

  return [v, setV];
};

export default function MLBOptimizerPage() {
  const [tab, setTab] = useStickyState("mlb.activeTab", "optimizer");

  return tab === "optimizer" ? (
    <MLBOptimizer activeTab={tab} setActiveTab={setTab} />
  ) : (
    <MLBLateSwap activeTab={tab} setActiveTab={setTab} />
  );
}